
   import React, { Component } from 'react';
   import '../App.css'
   import CoverNav from './CoverNav';
   import { withRouter } from 'react-router'
   import searchIcon from '../assets/search.svg';


   class MobileNav extends Component {

     state = {
       show: false,
     }

     toggleShow = () => {
       this.setState({
         show: !!this.state.show,
       })
     }

     render() {
       return (
         <div className="row mobile-nav d-block d-sm-none " style={ {height: '52px', backgroundColor: '#fff', color: '#fff' }}>
           <div className="col-md-12">
              <nav className="navbar navbar-dark bg-dark">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent"
                  aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation" style={{}}>
                  <img src={require('../assets/hamburger-icon.png')} style={{width: '28px'}}/>
                </button>
                <div className="search-sds-button" style={{ position: "absolute", right:'10px', top: '10px', display: 'block'}} >
                  <img src={searchIcon} alt="Search" className="search-icon"/>
                  <a href="/search" className="sds-link">Search SDS</a>
                </div>
              </nav>
              <div className="pos-f-t" style={{backgroundColor: '#5a2684', zIndex: 5}}>
               <div className="collapse row" id="navbarToggleExternalContent">
                 <nav className="nav flex-column front" style={{backgroundColor: '#5a2684', width:'100%', padding: '15px', color: '#fff'}}>
                   <a className="nav-link" href="/">Home</a>
                   <a className="nav-link" href="/our_products/all">Products</a>
                   <a className="nav-link" href="/support">Support</a>
                   <a className="nav-link" href="/news">News</a>
                   <a className="nav-link" href="/about">About</a>
                 </nav>
               </div>
            </div>
           </div>
          </div>
       );
     }
   }

   export default MobileNav



// WEBPACK FOOTER //
// src/components/MobileNav.js